/**
 * Renders a wallet balance, or a dash when there is no balance to render.
 *
 * The creditor modal used to interpolate these straight into a template literal. Optional
 * chaining short-circuits the WHOLE chain when the lookup returns nothing, so
 * `creditor?.creditor.walletBalance` yields `undefined` rather than throwing, and the modal
 * printed the literal text "undefined IRR" three times.
 *
 * **Zero is a real balance and must render as one.** Most creditors on stage sit at zero,
 * and that is precisely what an operator opens the modal to change — so the check is
 * explicitly against `undefined`/`null`, never truthiness. Simplifying this to
 * `value || '—'` compiles cleanly, passes any test that only covers the missing case, and
 * silently turns every zero-balance creditor into a dash.
 */
export const formatBalance = (
  value: number | undefined | null,
  currencyLabel: string
): string =>
  value === undefined || value === null ? '—' : `${value} ${currencyLabel}`
